export default __webpack_public_path__ + "static/media/interactive1.14c10022.svg";